import { useTranslation } from "react-i18next";

export const useApplicationLanguage = () => {
  const { i18n } = useTranslation();

  return i18n.resolvedLanguage;
};
